import Marquee from "react-fast-marquee";
import { Pulse } from "@phosphor-icons/react";

const TOKENS = [
  "Built for ER & Critical Care Nurses",
  "Not a substitute for clinical judgment",
  "Evidence-cited answers",
  "Live on iOS · 14-day free trial",
  "Stable-ish",
];

export default function MarqueeStrip() {
  return (
    <section
      data-testid="marquee-strip"
      className="relative border-y border-white/10 bg-black py-6 overflow-hidden"
    >
      <Marquee speed={42} gradient={false} pauseOnHover>
        {TOKENS.concat(TOKENS).map((t, i) => (
          <div key={i} className="flex items-center gap-8 px-8">
            <span className="font-display text-3xl sm:text-5xl font-extrabold text-stroke whitespace-nowrap">
              {t}
            </span>
            <Pulse size={28} weight="duotone" className="text-[#FF2A2A]" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
